export const LAST_VIEWED_PRODUCTS_RENDERED = 'LAST_VIEWED_PRODUCTS_RENDERED'
export const PRODUCT_INFO_FRAGMENT_RENDERED = 'PRODUCT_INFO_FRAGMENT_RENDERED'
export const LOAD_PRODUCTS_SERIE = 'LOAD_PRODUCTS_SERIE'
export const PRODUCT_ADDED_BUS_EVENT_TYPE = 'PRODUCT_ADDED'
export const PRODUCT_ADDED_FROM_PDP_BUNDLE_PRODUCTS = 'PDP_ADD_BUNDLE_PRODUCTS'

export const CROSS_SELL_MODAL_IS_OPENED = 'CROSS_SELL_MODAL_IS_OPENED'
export const CROSS_SELL_MODAL_CLOSED = 'CROSS_SELL_MODAL_CLOSED'
